import { Form, Formik } from 'formik';
import { Button, Stack } from '@mui/material';
import { Field } from 'formik';
import FormTextInput from './FormTextInput';
import { StorageLocation } from '../schema';
import * as Yup from 'yup';

export interface StorageLocationFormValues {
    name: string;
}

const schema = Yup.object().shape({
    name: Yup.string().trim().required('Name is required'),
});

interface Props {
    storageLocation?: StorageLocation;
    onSubmit: (values: StorageLocationFormValues) => Promise<void>;
    onCancel: () => void;
}

export default function StorageLocationForm({ storageLocation, onSubmit, onCancel }: Props) {
    const initialValues: StorageLocationFormValues = {
        name: storageLocation?.name ?? '',
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={schema}
            onSubmit={async (values, { setSubmitting }) => {
                try {
                    await onSubmit(values);
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            {({ isSubmitting }) => (
                <Form>
                    <Stack spacing={2}>
                        <Field name="name" component={FormTextInput} label="Name" required fullWidth />
                        <Stack direction="row" spacing={2} justifyContent="flex-end">
                            <Button onClick={onCancel} disabled={isSubmitting}>
                                Cancel
                            </Button>
                            <Button type="submit" variant="contained" disabled={isSubmitting}>
                                {storageLocation ? 'Save' : 'Create'}
                            </Button>
                        </Stack>
                    </Stack>
                </Form>
            )}
        </Formik>
    );
}
